import React, { Component } from 'react';
import { Trans } from 'react-i18next';

import Scale from './Scale.jsx';
import Orientation from './Orientation.jsx'
import CellDensity from './CellDensity.jsx';
import Grid from './Grid.jsx';

import i18n from '../resources/i18n';

import IMG_PAISAJE_COLOR from '../img/mapaPosterHorizontal.png';
import IMG_PAISAJE_GRIS from '../img/mapaPosterHorizontalNoSeleccionado.png';
import IMG_RETRATO_COLOR from '../img/mapaPosterVertical.png';
import IMG_RETRATO_GRIS from '../img/mapaPosterVerticalNoSeleccionado.png';
import IMG_PAISAJE_COLOR_LEYENDA from '../img/mapaPosterHorizontal_L.png';
import IMG_PAISAJE_GRIS_LEYENDA from '../img/mapaPosterHorizontalNoSeleccionado_L.png';
import IMG_RETRATO_COLOR_LEYENDA from '../img/mapaPosterVertical_L.png';
import IMG_RETRATO_GRIS_LEYENDA from '../img/mapaPosterVerticalNoSeleccionado_L.png';

import IMG_COORDENADAS_COLOR from '../img/coordenadas.svg';
import IMG_COORDENADAS_GRIS from '../img/coordenadas-gris.svg';
import IMG_CUADRICULA_COLOR from '../img/cuadricula.svg';
// import IMG_CUADRICULA_GRIS from '../img/cuadricula-gris.svg';
import IMG_CUADRICULA_GRIS from '../img/cuadricula-gris.png';
import IMG_1KM_COLOR from '../img/Cuadricula_1.svg';
import IMG_1KM_GRIS from '../img/Cuadricula_1-gris.svg';
import IMG_2KM_COLOR from '../img/Cuadricula_2.svg';
import IMG_2KM_GRIS from '../img/Cuadricula_2-gris.svg';
import IMG_5KM_COLOR from '../img/Cuadricula_5.svg';
import IMG_5KM_GRIS from '../img/Cuadricula_5-gris.svg';

class OptionMapSelectorPoster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstRow: '25K',
      secondRow: '50K',
      activeRow: this.props.activeRow,
      orientation: this.props.orientation,
      orientationIMGPaisajeColor: IMG_PAISAJE_COLOR,
      orientationIMGPaisajeGris: IMG_PAISAJE_GRIS,
      orientationIMGRetratoColor: IMG_RETRATO_COLOR,
      orientationIMGRetratoGris: IMG_RETRATO_GRIS,
      orientationIMGPaisajeColor_L: IMG_PAISAJE_COLOR_LEYENDA,
      orientationIMGPaisajeGris_L: IMG_PAISAJE_GRIS_LEYENDA,
      orientationIMGRetratoColor_L: IMG_RETRATO_COLOR_LEYENDA,
      orientationIMGRetratoGris_L: IMG_RETRATO_GRIS_LEYENDA,
      coordinatesIMGColor: IMG_COORDENADAS_COLOR,
      coordinatesIMGGris: IMG_COORDENADAS_GRIS,
      gridIMGColor: IMG_CUADRICULA_COLOR,
      gridIMGGris: IMG_CUADRICULA_GRIS,
      oneKMColor: IMG_1KM_COLOR,
      oneKMGris: IMG_1KM_GRIS,
      twoKMColor: IMG_2KM_COLOR,
      twoKMGris: IMG_2KM_GRIS,
      fiveKMColor: IMG_5KM_COLOR,
      fiveKMGris: IMG_5KM_GRIS,
      radioButtonOneChecked: 'checked',
      radioButtonTwoChecked: 'checked',
      parentState: this.props.parentState
    };
    this.showHelpGrid = false;
    this.enableLegend = this.props.parentState.posterLegend;
  }

  setStateGlobal = (state, event, value) => {
    const { setParentState } = this.props;
    setParentState(state, event);
  }

  configAutoScale(scale) {
    if (this.props.pluginEdition.currentScale !== scale) {
      this.props.pluginEdition.currentScale = scale;
      window.mapJs.getLayers().filter(l=>(l.legend && l.legend.endsWith('(Líneas)')) || l.impl_.name === '__draw__' || l.from_parameters || l.layerAddedByEditionTools).forEach(l=>l.getFeatures().forEach(f=>{
        f.impl_.olFeature_.changed();
      }));
    }
  }

  setActiveRow = (event) => {
    let {parentState} = this.props;
    if (event.target.value === 'secondRow') {
      this.configAutoScale(50);
      this.props.actionScale('1:50.000');//, 'secondRow'
      parentState.cellDensity = "5";
      if (this.showHelpGrid) {
        window.grid25Layer.setVisible(false);
        window.grid50Layer.setVisible(true);
      }

      window.mapJs.setMaxZoom(15);
      window.mapJs.removeLayers(window.mapJs.getLayers().find(l=>l.impl_.name === 'MTN'));
      window.mapJs.addLayers('TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*true*false*14');
    } else {
      this.configAutoScale(25);
      this.props.actionScale('1:25.000');//, 'firstRow'
      parentState.cellDensity = "1";
      if (this.showHelpGrid) {
        window.grid50Layer.setVisible(false);
        window.grid25Layer.setVisible(true);
      }

      window.mapJs.setMaxZoom(18);
      window.mapJs.removeLayers(window.mapJs.getLayers().find(l=>l.impl_.name === 'MTN'));
      window.mapJs.addLayers('TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*true*false*16');
    }

    this.setStateGlobal(parentState);
  }

  toggleHelpGrid = () => {
    if(this.showHelpGrid){
      window.grid50Layer.setVisible(false);
      window.grid25Layer.setVisible(false);
    }else{
      if(this.props.parentState.activeRow === 'secondRow'){
        window.grid50Layer.setVisible(true);
      }else{
        window.grid25Layer.setVisible(true);
      }
    }
    this.showHelpGrid = !this.showHelpGrid
    this.setStateGlobal(this.props.parentState);
  }

  toggleLegend = () => {
    this.enableLegend = !this.enableLegend;
    this.props.parentState.posterLegend = this.enableLegend;
    this.setStateGlobal(this.props.parentState);
    this.props.actionLegendPoster(this.props.parentState.posterLegend);
  }

  changeSelectedScale = (option) => {
    let {parentState} = this.props;

    switch (option) {
      case '40K':
        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:40.000';
          this.configAutoScale(40);
        }
        break;
      case '20K':
        if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:20.000';
          this.configAutoScale(20);
        }
        break;
      case '30K':
        if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:30.000';
          this.configAutoScale(30);
        }
        break;
      case '50K':
        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:50.000';
          this.configAutoScale(50);
        }
        break;
      case '60K':
        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:60.000';
          this.configAutoScale(60);
        }
        break;
      default:
        if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:25.000';
          this.configAutoScale(25);
        }
        break;
    }

    if ((['40K', '50K', '60K'].includes(option) && parentState.activeRow === "secondRow") || (['20K', '25K', '30K'].includes(option) && parentState.activeRow === "firstRow")) {
      this.props.actionScale(parentState.scale);//, option, parentState.activeRow
    }
    if (parentState.scale === '1:20.000' || parentState.scale === '1:25.000') {
      parentState.cellDensity = "1";
    } else if (parentState.scale === '1:30.000' || parentState.scale === '1:40.000'){
      parentState.cellDensity = "2";
    } else {
      parentState.cellDensity = "5";
    }

    this.setStateGlobal(parentState);
  }

  updateFramesValues = (option) => {
    let {parentState} = this.props;

    if (option === 'gridC') {
      if (parentState.gridFrame === 'active') {
        parentState.gridFrame = '';
      } else {
        parentState.gridFrame = 'active';
      }
    } else if (option === 'cuadriculaC') {
      if (parentState.coordinatesFrame === 'active') {
        parentState.coordinatesFrame = '';
      } else {
        parentState.coordinatesFrame = 'active';
      }
    }
    this.setStateGlobal(parentState);

  }

  changeSelectedOrientation = (option) => {
    let {parentState} = this.props;
    parentState.previousOrientation = parentState.orientation;
    parentState.orientation = option;
    this.setStateGlobal(parentState);
    this.props.actionOrientation(parentState.orientation);
  }

  changeSelectedCellDensity = (option) => {
    let {parentState} = this.props;
    parentState.cellDensity = option;
    this.setStateGlobal(parentState);
  }

  render() {

    const {asideClassName, classPanelButton, classPanelContent, parentState} = this.props;
    const {
      orientationIMGPaisajeColor,
      orientationIMGPaisajeGris,
      orientationIMGRetratoColor,
      orientationIMGRetratoGris,
      orientationIMGPaisajeColor_L,
      orientationIMGPaisajeGris_L,
      orientationIMGRetratoColor_L,
      orientationIMGRetratoGris_L,
      coordinatesIMGColor,
      coordinatesIMGGris,
      gridIMGColor,
      gridIMGGris,
      oneKMColor,
      oneKMGris,
      twoKMColor,
      twoKMGris,
      fiveKMColor,
      fiveKMGris,
    } = this.state;

    return (<aside className={asideClassName}>
      <div className={classPanelButton}>
        <div className='open'>
          <i className='fas fa-arrow'></i>
        </div>
      </div>
      <div className={classPanelContent}>
        {/* PRODUCTO */}
        <h2 className="h2Custom"><Trans i18nKey="step1.product">Producto</Trans></h2>
        <div className="scale first-step" style={{position:"relative"}}>

          <div className="radiobutton-row center scaleOption">
            <span><input type="radio" id="opt1" name="drone" value="firstRow" checked={parentState.activeRow === 'firstRow'} onChange={this.setActiveRow} />
            <label htmlFor="opt1">1:25.000</label></span>
            <div className="showGridHelp" style={{display:parentState.activeRow === 'firstRow'?"flex":"none"}}>
              <input id="opt1_grid" type="checkbox" checked={this.showHelpGrid} onClick={this.toggleHelpGrid} readOnly />
              <label style={{display: "inline-block"}}><Trans i18nKey="step1.seeGrid">Visualizar cuadrículas</Trans></label>
            </div>
          </div>

          <div className="radiobutton-row center scaleOption">
            <span><input type="radio" id="opt2" name="drone" value="secondRow" checked={parentState.activeRow === 'secondRow'} onChange={this.setActiveRow} />
            <label htmlFor="opt2">1:50.000</label></span>
            <div className="showGridHelp" style={{display:parentState.activeRow === 'secondRow'?"flex":"none"}}>
              <input id="opt2_grid" type="checkbox" checked={this.showHelpGrid} onClick={this.toggleHelpGrid} readOnly />
              <label style={{display: "inline-block"}}><Trans i18nKey="step1.seeGrid">Visualizar cuadrículas</Trans></label>
            </div>
          </div>
        </div>
        {/* ESCALA */}
        <h2 className="h2Custom fullScreenScaleREF"><Trans i18nKey="step1.scale">Escala</Trans></h2>
        <div className="scale second-step">

          <div className="radiobutton-row center scaleMenu">
            { this.props.parentState.activeRow === 'firstRow' ? (<React.Fragment>
            <Scale scale={parentState.scale} className='small' classNameActive='small active' label='30K' tooltipText='1:30.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='medium' classNameActive='medium active' label='25K' tooltipText='1:25.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='large' classNameActive='large active' label='20K' tooltipText='1:20.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            </React.Fragment>) : <React.Fragment>
            <Scale scale={parentState.scale} className='small' classNameActive='small active' label='60K' tooltipText='1:60.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='medium' classNameActive='medium active' label='50K' tooltipText='1:50.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='large' classNameActive='large active' label='40K' tooltipText='1:40.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            </React.Fragment>}
          </div>
        </div>
        {/* ORIENTACION */}
        <h2 className="h2Custom"><Trans i18nKey="step1.orientation">Orientación</Trans></h2>
        <div className="orientation center third-step">
          <Orientation classNameDiv="horizontal" className="center" src={this.enableLegend?orientationIMGPaisajeColor_L:orientationIMGPaisajeColor} srcChange={this.enableLegend?orientationIMGPaisajeGris_L:orientationIMGPaisajeGris} value={i18n.t('step1.horizontal')} label="Paisaje" checkedI="checked mc-check" selected={parentState.orientation} onClick={this.changeSelectedOrientation}/>
          <Orientation classNameDiv="vertical" className="center" src={this.enableLegend?orientationIMGRetratoColor_L:orientationIMGRetratoColor} srcChange={this.enableLegend?orientationIMGRetratoGris_L:orientationIMGRetratoGris} value={i18n.t('step1.vertical')} label="Retrato" checkedI="checked mc-check" selected={parentState.orientation} onClick={this.changeSelectedOrientation}/>
        </div>

        <div className="applyLegend">
          <input id="leyend_state" type="checkbox" checked={this.enableLegend} onClick={this.toggleLegend} readOnly/>
          <label><Trans i18nKey="step1.legend">Leyenda</Trans></label>
        </div>
        {/* CUADRÍCULAS */}
        <h2 className="h2Custom"><Trans i18nKey="step1.grid">Cuadrículas</Trans></h2>

        <div className="orientation center fourth-step">
          <Grid classNameDiv="gridC" className="center" src={gridIMGColor} srcChange={gridIMGGris} label={i18n.t('step1.grid')} checkedI="checked mc-check" selected={parentState.gridFrame} onClick={this.updateFramesValues}/>
          <Grid classNameDiv="cuadriculaC" className="center" src={coordinatesIMGColor} srcChange={coordinatesIMGGris} label={i18n.t('step1.coordinates')} checkedI="checked mc-check" selected={parentState.coordinatesFrame} onClick={this.updateFramesValues}/>
        </div>

        {/* DENSIDAD DE CUADRÍCULA */}
        { this.props.parentState.gridFrame !== '' || this.props.parentState.coordinatesFrame !== '' ? <React.Fragment><h2 className="h2Custom"><Trans i18nKey="step1.cellDimension">Dimensiones de la celda</Trans></h2>

        <div className="orientation center">
          <CellDensity classNameDiv="OneKMC" className="center" src={oneKMColor} srcChange={oneKMGris} value="1 Km" label="1" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
          <CellDensity classNameDiv="TwoKMC" className="center" src={twoKMColor} srcChange={twoKMGris} value="2 Km" label="2" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
          <CellDensity classNameDiv="FiveKMC" className="center" src={fiveKMColor} srcChange={fiveKMGris} value="5 Km" label="5" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
        </div>
        </React.Fragment> : <React.Fragment/>}

      </div>

    </aside>);
  }
}
export default OptionMapSelectorPoster;
